import updateApproval from "./edit/updateApproval";

export default updateApproval;
